import { render, staticRenderFns } from "./MyCourseInfo.vue?vue&type=template&id=0b61f50c&scoped=true&"
import script from "./MyCourseInfo.vue?vue&type=script&lang=js&"
export * from "./MyCourseInfo.vue?vue&type=script&lang=js&"
import style0 from "./MyCourseInfo.vue?vue&type=style&index=0&id=0b61f50c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b61f50c",
  null
  
)

export default component.exports